export enum MessageDirection {
  Outbound = 'outbound',
  Inbound = 'inbound',
}
